import { PageMetadata } from "../../../types/meta";

const metadata: PageMetadata = {
  title: "Blogginnlegg",
  description: "",
  url: "dashboard/admin/blogposts",
};

export { metadata };
